import { service } from "../utils/service";

// 新店注册
export function addStore(params) {
  return service({
    url: "/demay/ssm/store/addStore",
    method: "post",
    data: params
  });
}

//获取验证码
export function getSmsCode(params) {
  return service({
    url: "/demay/ssm/login/getSmsCode",
    method: "post",
    data: params
  });
}

// 分页查询门店信息 平台端-门店管理-门店审核-分页查询门店信息
export function storepage(params) {
  return service({
    url: "/demay/ssm/store/page",
    method: "post",
    data: params
  });
}

// 项目相关资源图片记录分页查询 平台端-项目相关资源图片记录分页查询
export function imgPage(params) {
  return service({
    url: "/demay/ssm/img/page",
    method: "post",
    data: params
  });
}



// WEBPACK FOOTER //
// ./src/api/api.js